/* eslint-disable */

export const stickyDivMixin = {
  data() {
    return {
    };
  },
  methods: {
    /**
     * applyStickyByID() will accept as a parameter a string that will be used to refer to an Element ID and retrieve the HTML element.
     *
     * The element we are referring to could be the Help/Script widget, Quote Summary widget, Search Form Widget (not results but search widget)
     * etc...
     * This method will be utlized by all the interview pages since they ALL have Help/Script widget, Quote Summary widget and finally used once
     * within Search Component.
     *
     * We will compare the height of whatever widget we pass in as an argument to the height of the Viewport of the browser minus the
     * height of the main top header. If our content height is less than Viewport minus header then we shall use a CSS styling of 'fixed' with a
     * top value. Originally we used CSS postion 'sticky' but IE11 does not support so using 'fixed'
     *
     * The purpose of this is so that while the user scrolls a form that is very long on the left-hand side, any other short widgets
     * in other areas of the page are treated independently when sticking and remain visisble while scrolling action takes place for a
     * toally different and independent widget.
     *
     *  @param {string} stickyDiv Determine if we need sticky functionality and set it on same element
     */
    applyStickyByID(stickyDiv) {
      const stickyDivID = document.getElementById(stickyDiv);

      const stickyHeightContOffsetHeight = stickyDivID.offsetHeight;
      const windowHeightMinusHeader = window.innerHeight - document.getElementById('header-logo-buttons').offsetHeight;
      const alreadyStuck = stickyDivID.classList.contains('fixed-widget');

      if (stickyHeightContOffsetHeight <= windowHeightMinusHeader && !alreadyStuck) {
        stickyDivID.classList.add('fixed-widget');
      } else if (stickyHeightContOffsetHeight > windowHeightMinusHeader && alreadyStuck) {
        stickyDivID.classList.remove('fixed-widget');
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/mixins/stickyDivMixin.js